import { TextLink } from 'braid-design-system';
import type React from 'react';

import { useAnalyticsContext } from '../../../modules/analytics/AnalyticsContext';
import type { TrackLinkProps } from '../../../modules/analytics/types';

interface Props {
  href: string;
  trackingData: TrackLinkProps;
  children?: React.ReactNode;
  weight?: 'regular' | 'weak';
  id?: string;
  target?: '_self' | '_blank';
}

const TrackLink = ({
  id,
  href,
  trackingData: data,
  children,
  weight,
  target = '_self',
}: Props) => {
  const {
    analytics: { trackLink },
  } = useAnalyticsContext();
  const onClick = () => {
    trackLink(data);
  };
  return (
    <TextLink
      data={{ cy: `${id}` }}
      href={href}
      onClick={onClick}
      target={target}
      weight={weight || 'regular'}
    >
      {children}
    </TextLink>
  );
};

export default TrackLink;
